import { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Separator } from "@/components/ui/separator";
import {
  LayoutDashboard,
  FileText,
  Receipt,
  Wrench,
  Menu,
  Archive,
} from "lucide-react";

const navItems = [
  { path: "/", label: "Dashboard", icon: LayoutDashboard },
  { path: "/quotation", label: "Quotation", icon: FileText },
  { path: "/invoice", label: "Invoice / Bill", icon: Receipt },
  { path: "/service-bill", label: "Service Bill", icon: Wrench },
  { path: "/records", label: "View Records", icon: Archive },
];

const NavItem = ({ item, onClick }) => {
  const location = useLocation();
  const isActive = location.pathname === item.path;

  return (
    <NavLink
      to={item.path}
      onClick={onClick}
      className={cn(
        "flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors duration-200",
        isActive
          ? "bg-primary text-primary-foreground shadow-md"
          : "text-muted-foreground hover:bg-secondary hover:text-foreground"
      )}
    >
      <item.icon className="h-5 w-5" />
      <span>{item.label}</span>
    </NavLink>
  );
};

const SidebarContent = ({ onItemClick }) => (
  <div className="flex flex-col h-full">
    {/* Logo Section */}
    <div className="p-6">
      <div className="flex items-center gap-3">
        <img
          src="https://customer-assets.emergentagent.com/job_384f5a02-e73c-441b-8711-7b4aa811af91/artifacts/1llnvk1o_be6ba909-56b0-4515-9de1-7b59366d1e68_Untitled.avif"
          alt="Kinetic Green Logo"
          className="h-12 w-auto object-contain"
          onError={(e) => {
            e.target.style.display = 'none';
          }}
        />
        <div>
          <h1 className="font-heading font-bold text-sm text-foreground leading-tight">
            SHREE MOBILITY
          </h1>
          <p className="text-xs text-muted-foreground">TRADE</p>
        </div>
      </div>
    </div>

    <Separator className="mx-4" />

    {/* Navigation */}
    <nav className="flex-1 p-4 space-y-1">
      {navItems.map((item) => (
        <NavItem key={item.path} item={item} onClick={onItemClick} />
      ))}
    </nav>

    {/* Footer */}
    <div className="p-4 border-t border-border">
      <div className="px-4 py-3 rounded-lg bg-secondary/50">
        <p className="text-xs text-muted-foreground text-center font-medium">
          Authorised Kinetic Green Dealer
        </p>
        <p className="text-xs text-muted-foreground text-center mt-1">
          Rampurhat, West Bengal
        </p>
      </div>
    </div>
  </div>
);

const Sidebar = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Desktop Sidebar */}
      <aside className="hidden lg:flex lg:fixed lg:left-0 lg:top-0 lg:bottom-0 lg:w-64 lg:flex-col bg-card border-r border-border z-30 no-print">
        <SidebarContent />
      </aside>

      {/* Mobile Sidebar */}
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetTrigger asChild className="lg:hidden fixed top-4 left-4 z-40 no-print">
          <Button variant="outline" size="icon">
            <Menu className="h-5 w-5" />
          </Button>
        </SheetTrigger>
        <SheetContent side="left" className="w-64 p-0">
          <SidebarContent onItemClick={() => setOpen(false)} />
        </SheetContent>
      </Sheet>
    </>
  );
};

export default Sidebar;
